import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function attributeReducer(state = initialState.attributes, action) {
  let newState = state;

    if(!action.status) {
        newState = Object.assign({}, state, {
            loading: true
        });

        return newState;
    }

  switch (action.type) {
      case types.CREATE_ATTRIBUTE:
            if (action.status === 'success'){
                newState = createAttribute(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.DELETE_ATTRIBUTE:
            if (action.status === 'success'){
                newState = deleteAttribute(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.LOAD_ALL_ATTRIBUTES:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    attributes: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_DEFAULT_ATTRIBUTES:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    defaultAttributes: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.PROJECT_SET_ATTRIBUTE_VALUE:
            if (action.status === 'success'){
                newState = projectSetAttributeValue(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.PROJECT_SET_ATTRIBUTE_VALUES:
            if (action.status === 'success'){
                newState = projectSetAttributeValues(state, action.data.projectID, action.data.attributeValues);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      default:
          return state;
  }
}

function createAttribute (state, attribute) {
    return Object.assign({}, state, {
        loading: false,
        attributes: [...state.attributes, attribute]
    });
}

function deleteAttribute (state, attributeID) {
    let attributeList = state.attributes;
    let index = list.findIndexByID(attributeList, attributeID);

    attributeList = list.remove(attributeList, index);

    return Object.assign({}, state, {
        loading: false,
        attributes: attributeList
    });
}

function projectSetAttributeValue (state, projectID, attributeValue) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function projectSetAttributeValues (state, projectID, attributeValues) {
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/attributeReducer.js
 **/